import * as net from 'util/Net';

export interface APIKey {
  id: number;
  key: string;
  created_at: string;
  expires_at: string | null;
  key_hint: string;
}

const API_KEYS_URL = '/1/api/users/me/keys/';

/**
 * Creates a new API key for the current user. The response includes the plaintext `key`, which is only
 * available at creation time and should be surfaced to the user immediately (it cannot be retrieved later).
 */
export function createAPIKey(): Promise<APIKey> {
  return net.postPromise({url: API_KEYS_URL});
}

/** Revokes (deletes) the current user's API key with the given id. */
export function revokeAPIKey(id: number): Promise<void> {
  return net.deletePromise({url: `${API_KEYS_URL}${id}`});
}
